import { types } from "mobx-state-tree";
import { flow } from "mobx";
import { api, v1Endpoint } from "../../api";

export const $products = types
  .model("Products", {
    currentProduct: types.frozen(null),
    loading: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setLoading(loading) {
      self.loading = loading;
    },
    setCurrentProduct(product) {
      self.currentProduct = product;
    },
    
    fetchProduct: flow(function* (productId) {
      self.setLoading(true);
      try {
        const response = yield api(v1Endpoint)
          .get(`/products/${productId}`)
          .then((res) => res.data);
        
        self.setCurrentProduct(response);
        return response;
      } catch (error) {
        console.error('Ошибка при загрузке товара:', error);
        self.setCurrentProduct(null);
        throw error;
      } finally {
        self.setLoading(false);
      }
    }),
    
    clearCurrentProduct() {
      self.currentProduct = null;
    },
  }))
  .create();
